import React, { useEffect, FunctionComponent } from "react"
import { useHistory } from "react-router-dom"
import Analytics from "shared/Analytics"

const AnalyticsDispatcher: FunctionComponent = ({ children }) => {
  const history = useHistory()

  useEffect(() => {
    Analytics.onPageLoad()
    return history.listen(Analytics.onPageLoad)
  }, [])

  return <>{children}</>
}
export default AnalyticsDispatcher
